import { Link } from 'react-router-dom'
import { ArrowRight, BookOpen } from 'lucide-react'
import { SEOHead } from '@/components/SEOHead'
import { ProductPageNav, ProductPageFooter } from '@/components/ProductPageNav'
import CookieConsent from '@/components/CookieConsent'
import { ARTICLES } from '@/pages/LearnArticle'

export default function LearnIndex() {
  return (
    <>
      <SEOHead
        title="Learn — OSINT & Threat Intelligence Explained | Sycek"
        description="Plain-language explainers on breach intelligence, stealer logs, BTRA risk scoring, and crypto wallet screening — from the team building Sycek OSINT."
        canonical="/learn"
      />

      <div className="min-h-screen bg-[#070b0e] text-white">
        <ProductPageNav />

        <section className="py-20 border-b border-white/[0.06]">
          <div className="container mx-auto px-6 max-w-3xl text-center">
            <div className="inline-flex items-center gap-2 bg-white/[0.04] border border-white/[0.08] rounded-full px-4 py-1.5 text-sm text-slate-400 mb-6">
              <BookOpen className="w-4 h-4" />
              Learn
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-5">OSINT and threat intelligence, explained</h1>
            <p className="text-xl text-slate-400 leading-relaxed">
              Plain-language breakdowns of the concepts and methodology behind Sycek's modules — what the terms actually mean, and how the platform uses them.
            </p>
          </div>
        </section>

        <section className="py-16">
          <div className="container mx-auto px-6 max-w-3xl space-y-5">
            {ARTICLES.map(article => (
              <Link
                key={article.slug}
                to={`/learn/${article.slug}`}
                className="block bg-white/[0.03] border border-white/[0.07] rounded-xl p-7 hover:border-white/15 hover:bg-white/[0.05] transition-all duration-200 group"
              >
                <h2 className="text-white font-bold text-xl mb-2 group-hover:text-green-400 transition-colors">{article.title}</h2>
                <p className="text-slate-400 leading-relaxed mb-4">{article.dek}</p>
                <span className="inline-flex items-center gap-1.5 text-sm text-green-400 font-medium">
                  Read more <ArrowRight className="w-3.5 h-3.5" />
                </span>
              </Link>
            ))}
          </div>
        </section>

        <ProductPageFooter />
      </div>
      <CookieConsent />
    </>
  )
}
